<template>
  <div>
    <app-header><app-nav></app-nav></app-header>

    <section class="container">
      <img src="/img/cartaz.jpg" alt="Cartaz" class="img-responsive center-block">
    </section>
  </div>
</template>

<script>
import AppHeader from '@/pages/layout/Header.vue'
import AppNav from './Nav.vue'

export default {
  name: 'Home',
  components: {
    AppHeader,
    AppNav
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>

</style>



// WEBPACK FOOTER //
// Home.vue?6aca15aa